import { BundleModifyTypes, PurchaseTypes } from "../app/shared/types/flows-config.types";

const base_api = "https://admin.phillyfoodworks.com";

export const environment = {
  production: true,
  apis: {
    v1: `${base_api}`,
    v2: `${base_api}/api/v2`,
    v3: `${base_api}/api/v3`,
    google: {
      places: 'AIzaSyBTHTviZ7QPtEjH29Jmmkp13RO8LPrxppM'
    },
    navego: {
      url: 'https://apis.navego.tech/api',
      key: 'dsfgrdf125fdffasd677rrfgr',
      clientNr: '3'
    },
    firebase: {
      apiKey: "AIzaSyBvncM8_VHCJ1vmo2vO0Tnkb2ZbcX1IEtQ",
      authDomain: "pf-cart-test.firebaseapp.com",
      projectId: "pf-cart-test",
      storageBucket: "pf-cart-test.appspot.com",
      messagingSenderId: "63357686320",
      appId: "1:63357686320:web:04272c905f11415e6313f5",
      measurementId: "G-CV45D0RDPW"
    },
    fireauth: {
      email: 'javier.franco@eliostudios.co',
      password: '@N4v3g0.T3ch.2024**'
    },
    klaviyo: {
      publicApiKey: 'WRBTcD'
    },
    maintenance: {
      url: 'https://ecommerce-configurations.navego.tech/api/v3/maintenance?url=phillyfoodworks.com'
    },
    authorize: {
      APILoginID: '6eUQ86ua',
      PublicClientkey: '25n6gtWe5GQkE9QrrTRXYkyk97R9fW5UUzVcpu322y9dWY838t6Cp2Kfv33h6KfE'
    }
  },
  application: {
    angular: 'Angular 17.3.7',
    bootstrap: 'Bootstrap 5.3.2',
    fontawesome: 'Font Awesome 6.5.1',
    name: 'Philly Foodworks',
    version: '1.0.0',
  },
  config: {
    bodyClass: 'app-pfw',
    crypto: {
      key: '!!!3nCrypt3d???',
    },
    flows: {
      territories: false,
      membership: true,
      settings: {
        toHide: {
          membership: 'Membership'
        },
        profile: {
          hasPickupLocationsFlow: false
        },
        deliveryDayUpdates: {
          displayOnlyActiveReescheduledOrder: true
        }
      },
      specialMembership: {
        defaultRoute: '/order',
        settings: {
          hideHeaderCategoriesNav: true
        },
      },
      order: {
        askForDonationOnSkip: true,
        showFreeDeliverySlider: false,
        voluntaryDonationFlow: true,
      },
      bundles: {
        modifyType: BundleModifyTypes.default
      },
      shop: {
        validateMarketState: true,
        displayCategoryName: true
      },
      login: {
        tempResetPassword: false
      },
      purchase: {
        type: PurchaseTypes.anet
      }
    },
    filesVersionNumber: {
      logo: 1
    },
    friendReferral: {
      baseUrl: 'https://phillyfoodworks.com/signup?utm_source=friend_referral&utm_medium=share&utm_campaign='
    },
    seo: {
      mainTitle: 'Local Organic Produce and Food Delivery in Philadelphia | Philly Foodworks',
      mainDescription: 'Discover Philly Foodworks: Local organic produce and food delivery in Philadelphia. Fresh, sustainable, and community-focused.',
      baseTitle: 'Philly Foodworks Local Organic Produce and Food Delivery',
      baseKeywords: ['local', 'organic', 'produce', 'food delivery', 'Philadelphia', 'Philly Foodworks'],
      type: 'website',
      baseURL: 'https://phillyfoodworks.com/'
    },
    contactEmail: 'info@phillyfoodworks.com'
  },
};
